export default function formRecaptcha (document, moduleHTML, appEventEmitter) {
  const form = moduleHTML
  const responseInput = form.querySelector('input[name="recap-response"]')
  const actionInput = form.querySelector('input[name="recap-action"]')
  const isStepperForm = !!form.dataset.jsFormStepper

  const readyToSubmit = () => {
    if (isStepperForm) {
      const [currentStep, lastStep] = form.dataset.jsFormStepper.split(':')
      if (currentStep === lastStep) {
        // This means the last step was shown with the last submit
        // Return false so as not to skip the last step
        form.dataset.jsFormStepper = 'ready'
        return false
      }
      return form.dataset.jsFormStepper === 'ready'
    }
    return true
  }

  form.addEventListener('submit', (event) => {
    const formReady = readyToSubmit()
    event.preventDefault()

    if ('grecaptcha' in window && formReady) {
      /* eslint-disable no-undef */
      grecaptcha.ready(() => {
        grecaptcha.execute(process.env.GATSBY_RECAPTCHA_SITE_KEY, { action: 'submit' })
          .then((token) => {
            /* eslint-enable no-undef */
            responseInput.value = token
            actionInput.value = 'submit'
            form.submit()
          })
      })
      return
    }
    // if grecaptcha fails to load for some reason, this ensures it still submits without it
    formReady && form.submit()
  })
}
